import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PContent from "../../atoms/text/PContent";
import Button from "../../atoms/button/Button";

const COOKIE_CONSENT_KEY = "cookieConsent";

const CookiesBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleConsent = (consent: boolean) => {
    localStorage.setItem(COOKIE_CONSENT_KEY, consent ? "accepted" : "rejected");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      role="dialog"
      aria-labelledby="cookie-banner-title"
      aria-describedby="cookie-banner-desc"
      className="fixed bottom-4 left-1/2 z-50 w-[min(92vw,960px)] -translate-x-1/2 rounded-xl border border-neutral-200 bg-white/95 p-4 shadow-lg backdrop-blur-sm sm:p-5 md:p-6"
      style={{
        borderImage:
          "repeating-linear-gradient(to right, rgba(51, 51, 51, 0.12) 0, rgba(51, 51, 51, 0.12) 20px, transparent 20px, transparent 40px) 100% 1",
        borderImageSlice: 1,
        borderImageRepeat: "stretch",
      }}
    >
      <div className="flex flex-col gap-4">
        <div className="flex-1 space-y-3">
          <h2
            id="cookie-banner-title"
            className="font-sans text-base font-bold text-neutral-900 sm:text-lg"
          >
            Cookies et traceurs sur AGBAZA
          </h2>
          <div id="cookie-banner-desc" className="space-y-2">
            <PContent className="text-sm font-medium text-neutral-800 sm:text-[15px] sm:leading-relaxed">
              Lors de votre première visite, le Ministère de la Santé (responsable de traitement)
              et NUKONYIYI (opérateur technique) vous informent de l&apos;usage de cookies sur la
              plateforme :
            </PContent>
            <ul className="list-disc space-y-1.5 pl-5 text-sm font-medium text-neutral-800 sm:text-[15px] sm:leading-relaxed">
              <li>
                <span className="font-semibold text-neutral-900">Strictement nécessaires</span>{" "}
                : authentification, sécurité (ex. protection CSRF), mémorisation de votre choix
                concernant ce bandeau.
              </li>
              <li>
                <span className="font-semibold text-neutral-900">Fonctionnalité</span> : préférences
                d&apos;affichage (langue, accessibilité) pour plus de confort.
              </li>
              <li>
                <span className="font-semibold text-neutral-900">Analytiques</span> : statistiques
                agrégées et anonymisées pour améliorer le service — sans identification personnelle
                ni accès à des données médicales.
              </li>
              <li>
                Aucun cookie publicitaire, commercial ou de partage vers les réseaux sociaux.
              </li>
              <li>Votre choix (accepter / refuser) est conservé six mois.</li>
            </ul>
            <PContent className="text-sm font-medium text-neutral-800 sm:text-[15px] sm:leading-relaxed">
              Pour les durées de conservation par type de cookie et la gestion de vos préférences,
              consultez la{" "}
              <Link
                to="/privacy-policy"
                className="font-semibold text-primary underline decoration-primary/40 underline-offset-2 transition-colors hover:text-primary/90"
              >
                politique de confidentialité et de gestion des cookies
              </Link>
              .
            </PContent>
          </div>
        </div>
        <div className="flex flex-col items-stretch gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-end">
          <Button
            type="button"
            variant="cancel"
            expandWidth
            className="mt-0 w-full sm:w-auto"
            onClick={() => handleConsent(false)}
          >
            Refuser
          </Button>
          <Button
            type="button"
            variant="validation"
            expandWidth
            className="mt-0 w-full sm:w-auto"
            onClick={() => handleConsent(true)}
          >
            Accepter
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookiesBanner;
